import './index.css';
import { Link } from 'react-router-dom';

const sectionStyle = { marginBottom: '48px' };
const h2Style = { fontSize: '24px', marginBottom: '16px', color: '#14213D', marginTop: '32px' };
const pStyle = { marginBottom: '16px', lineHeight: '1.6', color: '#475569' };
const ulStyle = { marginBottom: '24px', paddingLeft: '24px', lineHeight: '1.8', color: '#475569' };
const linkStyle = { color: '#007AFF', textDecoration: 'underline' };

const AccountDeletion = () => {
  return (
    <main style={{ padding: '72px 0 56px', minHeight: '80vh' }}>
      <div className="container" style={{ maxWidth: '800px' }}>
        <h1 style={{ fontSize: '36px', marginBottom: '12px', color: '#14213D' }}>
          Account Deletion
        </h1>
        <p style={{ marginBottom: '32px', lineHeight: '1.6', color: '#64748B', fontSize: '15px' }}>
          Last updated: 17 September 2026
        </p>

        <p style={pStyle}>
          This page explains how to request deletion of your account for the Posa platform,
          including the <strong>Posa Studio</strong> and <strong>Posa Sport</strong> apps,
          operated by Oxide Digital Technology. You can delete your account in the app or by
          contacting us. See also our{' '}
          <Link to="/privacy-policy" style={linkStyle}>Privacy Policy</Link>.
        </p>

        <section style={sectionStyle}>
          <h2 style={h2Style}>Delete your account in the app</h2>
          <p style={pStyle}>
            The fastest way to delete your account is from within the app:
          </p>
          <ol style={{ ...ulStyle, listStyleType: 'decimal' }}>
            <li>Open <strong>Posa Studio</strong> or <strong>Posa Sport</strong> and sign in.</li>
            <li>Go to <strong>Profile</strong>.</li>
            <li>Select <strong>Delete Account</strong> and confirm.</li>
          </ol>
          <p style={pStyle}>
            Completing this flow permanently deletes your account and removes related personal
            information associated with it, subject to the exceptions below.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>Request deletion by email</h2>
          <p style={pStyle}>
            If you cannot use the in-app option, email us to request account deletion:
          </p>
          <p style={pStyle}>
            <a href="mailto:support@oxide-digital.com?subject=Account%20deletion%20request" style={linkStyle}>
              support@oxide-digital.com
            </a>
          </p>
          <p style={pStyle}>Please include:</p>
          <ul style={ulStyle}>
            <li>the email address or phone number linked to your account;</li>
            <li>which app you use (Posa Studio or Posa Sport); and</li>
            <li>a clear request to delete your account.</li>
          </ul>
          <p style={pStyle}>
            We process deletion requests and will confirm when your account has been deleted.
            We aim to complete requests within a reasonable period after we verify ownership of
            the account.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>What data is removed</h2>
          <p style={pStyle}>When your account is deleted, we remove or anonymize data tied to your account, including:</p>
          <ul style={ulStyle}>
            <li>account and profile information;</li>
            <li>authentication identifiers linked to your account; and</li>
            <li>app data associated with your user profile.</li>
          </ul>
          <p style={pStyle}>
            Some information may be retained where we are required or permitted to keep it by law
            (for example, transaction or booking records needed for legal, accounting, or dispute
            purposes), or where data has been anonymized so it no longer identifies you. Retained
            data is handled as described in our{' '}
            <Link to="/privacy-policy" style={linkStyle}>Privacy Policy</Link>.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>Contact</h2>
          <p style={{ ...pStyle, marginBottom: 0 }}>
            <strong>Oxide Digital Technology</strong>
            <br />
            Email:{' '}
            <a href="mailto:support@oxide-digital.com" style={linkStyle}>
              support@oxide-digital.com
            </a>
            <br />
            Website:{' '}
            <a href="https://www.posasport.com" style={linkStyle}>
              https://www.posasport.com
            </a>
          </p>
        </section>

        <div
          style={{
            marginTop: '48px',
            paddingTop: '24px',
            borderTop: '1px solid #e5e7eb',
            lineHeight: '1.6',
            color: '#475569',
          }}
        >
          <p style={{ margin: 0 }}>
            The Posa platform is developed and maintained by Oxide Digital Technology.
          </p>
        </div>

        <div style={{ marginTop: '32px', paddingTop: '24px', borderTop: '1px solid #e5e7eb' }}>
          <Link
            to="/"
            style={{
              color: '#007AFF',
              textDecoration: 'none',
              fontWeight: '500',
            }}
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </main>
  );
};

export default AccountDeletion;
